(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemEditSbcourseTab", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningItems/edit/learningItemType/learningItemEditSBCourseTabView.html",
            controller: ["$scope", "$uibModal", LearningItemEditSBCourseTabCtrl],
            controllerAs: "vm"
        };
        function LearningItemEditSBCourseTabCtrl($scope, $uibModal) {
            var vm = this;
            vm.loading = true;
            $scope.$parent.vm.learningItemResourceObject.$promise.then(function () {
                vm.learningItem = $scope.$parent.vm.learningItem;
                vm.loading = false;
            }).catch(angular.noop);
            vm.openModal = function (learningItemSBCourse) {
                var $modalInstance = $uibModal.open({
                    templateUrl: "/app/learningItems/edit/learningItemType/learningItemEditSBCourseModalView.html",
                    controller: "LearningItemEditSBCourseModalCtrl as vm",
                    backdrop: "static",
                    resolve: {
                        learningItemSBCourse: function () {
                            return angular.copy(learningItemSBCourse);
                        }
                    }
                });
                $modalInstance.result.then(function (result) {
                    vm.learningItem.learningItemSBCourse = angular.copy(result);
                }).catch(angular.noop);
            };
        }
    });
})();
